import { render, staticRenderFns } from "./account_configuration.vue?vue&type=template&id=7c2a8ffc&"
import script from "./account_configuration.vue?vue&type=script&lang=js&"
export * from "./account_configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports